import { cn } from 'helpers/classnames';
import ProductImage from 'components/cart/ProductImage';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/floatingReturnItemList.scss';

export const FloatingReturnItemList = ({
  items,
  step,
  boxInfo,
  onNavigateToBoxSelection,
  onNavigateToReturnInitiate,
  onCancelReturn,
  hasEmptyBoxes
}) => {
  const { testId } = useMartyContext();
  const makeContinueButton = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    switch (step) {
      case 'SELECT_RETURN_ITEMS':
        return (
          <button type="button" data-test-id={testId('continueReturnButton')} onClick={onNavigateToBoxSelection}>
            Continue
          </button>
        );
      case 'SELECT_BOX':
        // eslint-disable-next-line marty/jsx-singleline-max-props
        return (
          <button type="button" disabled={hasEmptyBoxes()} data-test-id={testId('continueReturnButton')} onClick={onNavigateToReturnInitiate}>
            Continue
          </button>
        );
    }
  };

  const makeBoxedItems = () => {
    const boxInfoEntries = Object.entries(boxInfo || {});
    if (boxInfoEntries.length < 2 || step === 'SELECT_RETURN_ITEMS') {
      return items.map(item => <ProductImage showFixedQuantity={true} key={item.itemUniqueId} className={css.image} item={item.product} />);
    } else if (step === 'SELECT_BOX') {
      return boxInfoEntries.map(([num, { items }]) =>
        items.map(item => (
          <ProductImage
            data-box-num={num}
            showFixedQuantity={true}
            key={item.itemUniqueId}
            className={cn(css.image, css.boxNum)}
            item={item.product}
          />
        ))
      );
    }
  };

  return (
    <div className={css.returning} data-test-id={testId('floatingReturnItemListWrapper')}>
      <h3 className="zappos:body-m">Items you are returning ({items.length})</h3>
      <div className={css.boxedItems} aria-hidden={true}>
        {makeBoxedItems()}
      </div>
      <div className={css.buttons}>
        {makeContinueButton()}
        <button type="button" data-test-id={testId('cancelReturnButton')} onClick={onCancelReturn}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default FloatingReturnItemList;
